<itl-wizard-page
  [pageTitleTransPath]="'careproposal.create.article.info.title'"
  [isSinglePage]="true"
  [pageIsValid]="form.valid"
  (doneClicked)="save()"
  (cancelClicked)="cancel()"
>
  <itl-section title="Artikel" [isDetail]="false">
    <itl-integratedcare-article [article]="article" [icon]="'alberta-article'"> </itl-integratedcare-article>
    <itl-error-display [control]="form"> </itl-error-display>
  </itl-section>
  <div class="quantityIntervalWrapper">
    <itl-section
      [title]="'components.careproposal.article.info.quantity' | translate"
      class="quantitySelection"
      [isDetail]="false"
    >
      <itl-numberUpDown
        [title]="'careproposal.create.article.info.quantity' | translate"
        [(ngModel)]="articleLine.dosage.quantity"
        [formControl]="quantity"
        icon="alberta-packaging"
        [required]="true"
      ></itl-numberUpDown>
      <itl-selection
        [title]="'careproposal.create.article.info.unit' | translate"
        [(ngModel)]="articleLine.dosage.packagingId"
        [values]="units"
        [formControl]="packagingId"
        icon="alberta-packaging"
        [required]="true"
      ></itl-selection>
    </itl-section>
    <itl-section
      [title]="
        showIntervall
          ? ('components.careproposal.article.info.interval' | translate)
          : ('components.careproposal.article.info.noIntervallAtAidsForUse' | translate)
      "
      class="intervalSelection"
      [isDetail]="false"
    >
      <ng-container *ngIf="showIntervall">
        <itl-numberUpDown
          [title]="'careproposal.create.article.info.interval' | translate"
          [(ngModel)]="articleLine.dosage.duration.amount"
          [formControl]="interval"
          icon="alberta-interval"
          [required]="true"
        >
        </itl-numberUpDown>
        <itl-selection
          [title]="'careproposal.create.article.info.period' | translate"
          [(ngModel)]="articleLine.dosage.duration.timePeriod"
          [values]="periods"
          [formControl]="period"
          icon="alberta-interval"
          [required]="true"
        ></itl-selection>
      </ng-container>
    </itl-section>
  </div>
  <itl-section
    [title]="'components.careproposal.article.info.annotation' | translate"
    [isDetail]="false"
    *ngIf="displayAnnotation"
  >
    <itl-text
      [title]="'careproposal.create.article.info.annotation' | translate"
      [(ngModel)]="articleLine.annotation"
      [formControl]="annotation"
      icon="alberta-comment"
      [maxlength]="annotationLimit"
    ></itl-text>
  </itl-section>
</itl-wizard-page>
